import styled, { css } from "styled-components";
import { type SpaceProps, space } from "styled-system";
import { theme } from "../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import * as Type from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import { getBreakpoint } from "../../../../../../../common-deprecated/themes/common";
import * as Button from "../../../../../../../common-deprecated/styles/v2/toyota/components/Button";

export const DetailsWrapper = styled.div`
    &::before {
        position: absolute;
        left: 0;
        right: 0;
        content: "";
        background-color: ${theme.colors.primaryWhite};
    }
`;

export const Row = styled.div<{ align?: "start" | "end"; iconPosition?: "left" | "right" }>`
    display: flex;
    align-items: center;
    justify-items: end;
    justify-content: ${({ align }) => (align ? `flex-${align}` : "space-between")};
    padding: ${theme.space[2]}px 0;
    white-space: pre-wrap;
    border-bottom: 1px solid ${theme.colors.grey2};

    .icon {
        flex-shrink: 0;
        ${({ iconPosition }) =>
            iconPosition &&
            css`
                    margin-${iconPosition === "left" ? "right" : "left"}: ${theme.space[1]}px;
                `};
    }
`;

export const PriceCol = styled.div`
    padding: 0 ${theme.spacer / 2}px;
    white-space: nowrap;
`;

export const Title = styled.div<{ isRTL?: boolean } & SpaceProps>`
    width: 100%;
    padding-bottom: ${theme.space[3]}px;
    border-bottom: 1px solid ${theme.colors.grey2};
    ${space}

    ${Type.H3} {
        font-size: 2rem;

        @media ${getBreakpoint("up", "lg")} {
            font-size: 2.8rem;
        }
    }

    a {
        margin-top: ${theme.space[1]}px;
    }

    ${Button.Link} {
        font-size: 1.6rem;
        line-height: 2.4rem;
    }

    @media ${getBreakpoint("up", "md")} {
        display: flex;
        align-items: center;
        justify-content: space-between;
        a {
            margin-top: 0;
        }

        ${({ isRTL }) =>
            isRTL &&
            css`
                flex-direction: column;
                align-items: flex-start;
            `};
    }
`;

export const Panel = styled.div<{ visible?: boolean }>`
    display: ${({ visible }) => (visible ? "block" : "none")};
`;
